export default __webpack_public_path__ + "static/atlas-copco-e9b7bdb46df7e9723ef2a7cae9b66364.png";